import React from "react";
import { Button, Card, Divider, Form, Input, Typography } from "antd";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";
import { BackButton } from "../components/BackButton";
import { useAddUser } from "../queries/user";
import { CheckOutlined } from "@ant-design/icons";

const ACCEPT_INVITE_BASEURL =
  process.env.REACT_APP_FRONTEND_URL + "/accept-invite/";

const AddUserPage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.add-user"));
  const [form] = Form.useForm();
  const { mutate: addUser, isPending, isSuccess, data: newUser } = useAddUser();

  const onFinish = (values: { email: string }) => {
    addUser(values);
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 500,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginTop: "2.5rem",
      }}
    >
      <Card title={t("pages.new-user.new-user")} style={{ width: 500 }}>
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Form.Item
            label={t("pages.new-user.email")}
            name="email"
            rules={[
              {
                required: true,
                message:
                  t("pages.new-user.email-required") || "Email is required",
              },
              {
                type: "email",
                message:
                  t("pages.new-user.invalid-email-info") ||
                  "Please enter a valid email",
              },
            ]}
          >
            <Input placeholder="example@email.com" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              style={{ float: "right" }}
              type="primary"
              htmlType="submit"
              loading={isPending}
            >
              {isSuccess ? <CheckOutlined /> : ""}
              {t("pages.new-user.invite")}
            </Button>
          </Form.Item>
        </Form>
        {isSuccess && (
          <>
            <Divider />
            <Typography.Text style={{ fontWeight: "bold" }}>
              {t("pages.new-user.invite-link")}:
            </Typography.Text>
            <br />
            <Typography.Text copyable>
              {ACCEPT_INVITE_BASEURL + newUser.data.inviteToken}
            </Typography.Text>
          </>
        )}
      </Card>
      <BackButton />
    </div>
  );
};

export default AddUserPage;
